import CIMSTable from 'components/CIMSTable'
import { useIssueTypesContext } from './IssueTypesContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useEdit } from './hooks/useEdit'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'
import { useExpand } from './hooks/useExpand'

const IssueTypes: React.FC = () => {
  const { issueTypes, loading, refetch: onReload } = useIssueTypesContext()
  return (
    <CIMSTable
      records={issueTypes}
      rowKey="id"
      columns={useColumns()}
      loading={loading}
      actions={{
        header: { onReload, create: useCreate() },
        row: { edit: useEdit(), remove: useRemove(), restore: useRestore() },
      }}
      expand={useExpand()}
    />
  )
}

export default IssueTypes
